import { render } from "./DetailTabUser.vue?vue&type=template&id=3f92fecb"
import script from "./DetailTabUser.vue?vue&type=script&lang=js"
export * from "./DetailTabUser.vue?vue&type=script&lang=js"

import "./DetailTabUser.vue?vue&type=style&index=0&id=3f92fecb&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__